import { atom } from 'jotai'

export const priceChartModalOpenAtom = atom(false)
